import { projectRequest } from 'api';
import { AxiosResponse } from 'axios';
import { ISupplierAnnouncement, ISupplierAnnouncementQuery } from './types';

// GET /announcements (DSS_B) - Simplified supplier announcement list with pagination
// The API will return filtered and sorted announcements server-side (is_sticky priority + date desc)
// Backend handles all sorting, filtering, and pagination
const getSupplierAnnouncements = (query?: ISupplierAnnouncementQuery) => {
  const params = new URLSearchParams();
  
  if (query?.page) params.append('page', query.page);
  if (query?.limit) params.append('limit', query.limit);
  if (query?.q) params.append('q', query.q);
  
  const queryString = params.toString();
  const url = queryString ? `/announcements?${queryString}` : '/announcements';
  
  return projectRequest(false, 'v2').get(url) as Promise<AxiosResponse<ISupplierAnnouncement[]>>;
};

export default getSupplierAnnouncements;